import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import * as serviceWorker from "./serviceWorker";

// MUI CSS Baseline is handled by ThemeProvider

// Amplify
import { Amplify } from "aws-amplify";
import config from "../src/conf/config";

Amplify.configure({
  Auth: {
    Cognito: {
      region: config.cognito.REGION,
      userPoolId: config.cognito.USER_POOL_ID,
      userPoolClientId: config.cognito.APP_CLIENT_ID,
      identityPoolId: config.cognito.IDENTITY_POOL_ID,
      signUpVerificationMethod: 'code'
    }
  },
  API: {
    REST: {
      devices: {
        endpoint: config.apiGateway.URL,
        region: config.apiGateway.REGION
      },
      challenges: {
        endpoint: config.apiGateway.URL,
        region: config.apiGateway.REGION
      },
      analytics: {
        endpoint: config.apiGateway.URL,
        region: config.apiGateway.REGION
      }
    }
  }
});

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
